module.exports = __webpack_public_path__ + "static/media/meeting_anim.0cae8e14.png";